import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const post = ({
    addressId,
    nickName,
    skuId,
    quantity,
    type
}) => {
    return instance.post(apis.order.Post, {
        addressId,
        nickName,
        skuId,
        quantity,
        type
    })
}

const list = (orderStatusId, page, limit) => {
    return instance.post(apis.order.List, {
        orderStatus: orderStatusId,
        pageSize: limit,
        page: page
    });
}
const detail = (orderNo) => {
    return instance.get(apis.order.Detail + "?orderId=" + orderNo)
}
const cancel = (orderNo) => {
    return instance.put(apis.order.Cancel + "?orderId=" + orderNo)
}
// 次日退款
const refund = (form, orderNo) => {
    return instance.post(apis.order.Refund, {
        orderId: orderNo,
        expressNo: form.no,
        expressName: form.name
    })
}
// 当日退款
const refundDay = (data) => {
    return instance.post(apis.order.OnRefund, '"' + data + '"', {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 退款列表
const refundlist = (orderStatusId,page,limit) => {
    return instance.post(apis.order.RefundOrderList,{
        orderRefundStatus: orderStatusId,
        pageSize: limit,
        page: page
    })
}

// 获取限购商品详情
const GetLimitGoodsDetail = (data) => {
    return instance.post(apis.Goods.GetLimitGoodsDetail,data)
}

// 获取限购商品详情
const checkOrderExpire = (id) => {
    return instance.get(apis.order.CheckOrderExpire + "?id=" + id)
}

export default {
    post,
    list,
    detail,
    cancel,
    refund,
    refundDay,
    refundlist,
    GetLimitGoodsDetail,
    checkOrderExpire
}